import { Component } from "@angular/core";
import { MatChipEditedEvent, MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { inject } from "@angular/core";

export interface Fruit {
    name: string;
}

@Component({
    selector: "chip-storybook",
    templateUrl: "./chip-storybook.component.html",
})
export class ChipStorybookComponent {
    addOnBlur = true;
    
    readonly separatorKeysCodes = [ENTER, COMMA] as const;
    fruits: Fruit[] = [{ name: 'Lemon' }, { name: 'Lime' }, { name: 'Apple' }];

    announcer = inject(LiveAnnouncer);

    add(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();

        if (value) {
            this.fruits.push({ name: value });
        }

        event.chipInput!.clear();
    }

    remove(fruit: Fruit): void {
        const index = this.fruits.indexOf(fruit);

        if (index >= 0) {
            this.fruits.splice(index, 1);

            this.announcer.announce(`Removed ${fruit}`);
        }
    }

    edit(fruit: Fruit, event: MatChipEditedEvent) {
        const value = event.value.trim();

        if (!value) {
            this.remove(fruit);
            return;
        }

        const index = this.fruits.indexOf(fruit);
        if (index >= 0) {
            this.fruits[index].name = value;
        }
    }
}
